import { useState } from "react";
import { IconButton } from "@mui/material";
import images from "../../assets/images";

const ColumnHeader = ({ column }: any) => {
  const [isRenameColumn, setIsRenameColumn] = useState(false);
  const [newColumnTitle, setNewColumnTitle] = useState(column.title);

  const handleRenameColumn = () => {
    column.title = newColumnTitle;
    setIsRenameColumn(false);
  };

  return (
    <div className="kanban-column lead-card">
      {isRenameColumn ? (
        <div className="create-status-box">
          <input
            type="text"
            placeholder="Enter new status title"
            value={newColumnTitle}
            onChange={(e) => setNewColumnTitle(e.target.value)}
          />
          <div className="add-btns">
            <button onClick={() => handleRenameColumn()}>Rename</button>
            <button onClick={() => setIsRenameColumn(false)}>Cancel</button>
          </div>
        </div>
      ) : (
        <h2
          className="kanban-column-title"
          onDoubleClick={() => setIsRenameColumn(true)}
        >
          {column.title}
        </h2>
      )}

      <span className="count-length-text">{column.cards.length}</span>

      <IconButton color="inherit" size="small" className="more-menu-btn">
        <img src={images.more} alt="more icon" />
      </IconButton>
    </div>
  );
};

export { ColumnHeader };
export default ColumnHeader;
